import * as React from 'react'
import { Formik } from 'formik'

import { useActions } from '../hooks'
import type { CustomFieldFormProps } from '../typings'

import { FormFields } from './FormFields'

export function FormFieldWrapper(props: CustomFieldFormProps) {
  const {
    onClose,
    initialValues = {
      title: '',
      fieldType: '',
      options: [],
    },
  } = props

  const { onSave, onValidate, isUpdate } = useActions(props)

  return (
    <Formik
      onSubmit={onSave}
      validate={onValidate}
      initialValues={initialValues}
    >
      <FormFields onClose={onClose} isUpdate={isUpdate} />
    </Formik>
  )
}
